import {
  StatementMessageModel,
} from '../interfaces/statement-messaging-run.model';
import * as _ from 'lodash';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root', // Makes it available globally
})
export class FilterUtil {

  /**
   * Compare strings with options
   */
  private compareStrings(
    runValue: string,
    filterValue: string,
    exactMatch: boolean,
    caseSensitive: boolean,
  ): boolean {
    const run = caseSensitive ? runValue : runValue.toLowerCase();
    const filter = caseSensitive ? filterValue : filterValue.toLowerCase();

    return exactMatch ? run === filter : run.includes(filter);
  }

/*  /!**
   * Remove empty values from Record using lodash
   *!/
  private cleanSearchCriteria(criteria: Record<string, string>): Record<string, string> {
    // Remove empty, null, undefined values
    return _.pickBy(criteria, (value) => !_.isEmpty(value)) as Record<string, string>;
  }*/

/*  /!**
   * we are using regex instead of using Date object. Because it is memory effective.
   * @param dateString MM/DD/YYYY formated date string
   * @private
   *!/
  private convertToISODate(dateString: string): string {
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      const [month, day, year] = dateString.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return '';
  }*/

  /**
   * Alternative: More flexible filter method with exact/partial matching
   */
  public filterMessageDataAdvanced(
    messages: StatementMessageModel[],
    criteria: Record<string, string>,
    options: { exactMatch?: boolean; caseSensitive?: boolean } = {},
  ): StatementMessageModel[] {
    const { exactMatch = true, caseSensitive = true } = options;
    return messages.filter((message) => {
      // Get all non-empty criteria
      const validCriteria = Object.entries(criteria).filter(
        ([key, value]: [string, string]): boolean => !_.isEmpty(value),
      );

      // Check if ALL criteria match (AND logic)
      return validCriteria.every(([key, value]) => {
        const runValue: string = this.getMessageValue(message, key);

        if (_.isNil(runValue)) {
          return false;
        }

        // Handle string comparisons
        return this.compareStrings(runValue.toString(), value, exactMatch, caseSensitive);
      });
    });
  }

  /**
   * Get run value by key
   */
  private getMessageValue(run: StatementMessageModel, key: string): any {
    const mapping: Record<string, keyof StatementMessageModel> = {
      message_number: 'messageId',
      message_type: 'messageTypeCode',
      permanent: 'permanentMessageFlag',
      verified: 'verifyFlag',
    };
    const fieldName = mapping[key];
    return fieldName ? run[fieldName] : null;
  }
}
